import { date, object, ref, string } from 'yup';
import { IUser } from '../../common';
import { IResident } from '../resident-creation';

export interface INews {
  id: string;
  text: string;
  displayFrom: Date;
  displayTo: Date | null;
  createdBy?: IUser;
  createdById: string;
  createdAt: Date;
  resident: IResident | null;
  houseDivisionId?: string | null;
}

export interface INewsCreate {
  text: string;
  displayFrom: Date;
  displayTo?: Date | null;
  residentId: string | null | undefined;
  houseDivisionId?: string | null;
}

export interface INewsUpdate {
  id: string;
  text: string;
  displayFrom: Date;
  displayTo?: Date | null;
  residentId: string | null;
  houseDivisionId?: string | null;
}

export const NewsCreateSchema = object({
  text: string().required(),
  displayFrom: date().required(),
  displayTo: date().optional().nullable().min(ref('displayFrom')).default(null),
  residentId: string().notRequired().nullable(),
  houseDivisionId: string().notRequired().nullable(),
});

export const NewsUpdateSchema = object({
  id: string().required(),
  text: string().required(),
  displayFrom: date().required(),
  displayTo: date().optional().nullable().min(ref('displayFrom')).default(null),
  residentId: string().notRequired().nullable(),
  houseDivisionId: string().notRequired().nullable(),
});
